import React from 'react';
import axios from 'axios';
import styled from '@emotion/styled';
import { useAlerts } from 'components/Alerts';
import StaticCategoriesSelect from 'components/categories/StaticCategoriesSelect';

const Placeholder = styled.span`
  color: #0b1c3e;
  & u {
    cursor: pointer;
  }
`;

const CategorySelect = ({ subscriptionUpdateRoute, options, defaultValue, addCategoryLabel, allCategoriesLabel }) => {
  const [categories, setCategories] = React.useState(defaultValue || []);
  const alerts = useAlerts();

  const onChange = React.useCallback((value) => {
    setCategories(value);
    const payload = {
      project_subscription: {
        category_ids: (value || []).map((c) => (c.value))
      }
    };

    axios.patch(subscriptionUpdateRoute, payload)
      // .then(() => alerts.success('Updated subscribed categories.'))
      .catch(() => alerts.error('Could not update subscribed categories'));
  }, [subscriptionUpdateRoute]);

  return (
    <StaticCategoriesSelect
      value={categories}
      options={options}
      onChange={onChange}
      placeholder={<Placeholder>{allCategoriesLabel} <span className="ml-4 primary-color">+ {addCategoryLabel}</span></Placeholder>}
    />
  );
};

export default CategorySelect;
